/* istanbul ignore file */
export const getPogCost = (product) => {
  const recommendedQty = product?.pogqty ?? 1;
  const memberCost = product?.pogcost ?? 0;
  return recommendedQty * memberCost;
};

// get adjusted qty based on multiplier, pog qty and missing qty(missingSkus)
export const getAdjustedQty = (multiplier = 1, pogQty = 0, missingQty = 0) => {
  const isMissing = missingQty > 0;
  if (isMissing) {
    const qty = pogQty * multiplier - (pogQty - missingQty);
    return qty > 0 ? qty : 0;
  }
  return 0;
};

export const getTierLevelForQty = (product) => {
  if (!product?.tiered && product?.zoned_mbrcost_ind === "N") {
    return null;
  }
  const qty = parseInt(product?.adjqty);
  let tierLevel = 1;
  if (product.Tier_1_Qty === 0) {
    tierLevel = 2;
  }
  if (isNaN(qty)) {
    return tierLevel;
  }
  if (
    product.Tier_2_Cost &&
    parseFloat(product.Tier_2_Cost) !== 0 &&
    qty >= product.Tier_2_Qty
  ) {
    tierLevel = 2;
  }
  if (
    product.Tier_3_Cost &&
    parseFloat(product.Tier_3_Cost) !== 0 &&
    qty >= product.Tier_3_Qty
  ) {
    tierLevel = 3;
  }
  if (
    product.Tier_4_Cost &&
    parseFloat(product.Tier_4_Cost) !== 0 &&
    qty >= product.Tier_4_Qty
  ) {
    tierLevel = 4;
  }
  return tierLevel;
};

export const getTierBasedCost = (product, tierLevel) => {
  if (!tierLevel) {
    return product?.cost;
  }
  const tierCostKey = `Tier_${tierLevel}_Cost`;
  return product[tierCostKey];
};

const discountCalculator = (totalCost, discount) => {
  return totalCost - (totalCost * discount) / 100;
};

// Get updated recommended qty value based on discount multiplier.
const getRecommendedQty = (product) => {
  const pogQty = product?.pogqty || 0;
  const discountMultiplier = product?.discMultiplier || 1;
  return pogQty * discountMultiplier;
};

export const getDiscountedAdjCost = (product, tierCost, OneXQty) => {
  const adjQty = product?.adjqty ?? 0;
  const missingSkus = product?.missingskus ?? 0;
  const pogQty = getRecommendedQty(product);
  const discountValue = product?.discountPercentage ?? 0;
  let totalCost = tierCost * adjQty;

  // Missing qty is 0 or less than 0 then no discount.
  if (missingSkus <= 0) {
    return {
      adjCost: tierCost * adjQty,
      totalCost: tierCost * adjQty,
    };
  }

  // If adj. qty is more than missing then apply discount to 1x qty only not whole qty.
  if (adjQty > pogQty) {
    totalCost = tierCost * (adjQty - OneXQty);
    return {
      adjCost:
        totalCost + discountCalculator(OneXQty * tierCost, discountValue),
      totalCost: totalCost + OneXQty * tierCost,
    };
  }

  return {
    adjCost: discountCalculator(totalCost, discountValue),
    totalCost: totalCost,
  };
};

// Make sure you pass item with updated/latest multiplier
export const getTierBasedItemValues = (
  item,
  itemAdjQty,
  isOrderEntity = false
) => {
  //Step 0: Get calculated Adjusted Quantity
  const product = { ...item, adjqty: itemAdjQty };
  //Step 1: Get Tier Level
  const tier = getTierLevelForQty(product);
  //Step 2: Get Tier Cost Value using tier level (Member Cost)
  const pogCost = getTierBasedCost(product, tier);

  //Step 2.1: get 1x adj. qty and tier cost.
  let OneXQty = 0;
  if (product?.multiplier) {
    const qty = getRecommendedQty(product);
    OneXQty = getAdjustedQty(1, qty, qty);
  }

  //Step 3: Get Discounted Cost using tier cost and product adj. qty.
  const { adjCost, totalCost } = getDiscountedAdjCost(
    product,
    pogCost,
    OneXQty,
    isOrderEntity
  );

  return { pogCost, adjCost, totalCost };
};
